/*
 * @Description: api converter for sales channel promotion
 * @Author: Chris
 * @Date: 2021-03-23 17:15:59
 */

import { randomNumber } from '@/src/tools/helper';
import { getI18nFromGeneral } from '@/src/tools/tools';
import { IEdm, IFeaturedProduct } from '@/src/types/common/SalesChannel';
import {
  EnumPromotionCollapseId,
  EnumPromotionPopWindowType,
} from 'src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/common';
import { reduxUpdatedStatusControl } from 'src/tools/helper';
// import { validationSingle } from 'src/pages/SalesChannelContentEditor/SalesChannelEditorPromotion/validation';

export const convertDataFromServerToRedux = (data) => {
  const {
    uuid,
    hasError,
    featuredProducts = {},
    edm = {},
    popupWindows = {
      inUse: [],
      pending: [],
      previous: [],
      editing: [],
    },
    storeUuid,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    errorDetail,
    translationEnabled = false,
  } = data;

  // import  const isNew = !uuid;

  const _popupWindows = {
    inUse:
      convertUuidToId(
        (popupWindows.inUse || []).map((i) => {
          return { ...i, _status: 'active' };
        }),
      ) || [],
    pending:
      convertUuidToId(
        (popupWindows.pending || []).map((i) => {
          return { ...i, _status: 'pending' };
        }),
      ) || [],
    previous:
      convertUuidToId(
        (popupWindows.previous || []).map((i) => {
          return { ...i, _status: 'previous' };
        }),
      ) || [],
    editing:
      convertUuidToId(
        (popupWindows.editing || []).map((i) => {
          return { ...i, _status: 'editing' };
        }),
      ) || [],
  };

  const _windowInArr = [
    ..._popupWindows.inUse,
    ..._popupWindows.pending,
    ..._popupWindows.previous,
    ..._popupWindows.editing,
  ];
  //console.log(_popupWindows);
  const collapseOpen = {
    [EnumPromotionCollapseId.featuredProducts]: false,
    [EnumPromotionCollapseId.edm]: false,
    ..._windowInArr.reduce((pre, now: any) => {
      const { id } = now;
      return { ...pre, [id]: false };
    }, {}),
  };

  const collapseErrorMsgDisplay = {
    [EnumPromotionCollapseId.featuredProducts]: {
      hasError: false,
      display: hasError,
    },
    [EnumPromotionCollapseId.edm]: { hasError: false, display: hasError },
    ..._windowInArr.reduce((pre, now: any) => {
      const { id } = now;
      return { ...pre, [id]: { hasError: false, display: hasError } };
    }, {}),
  };

  if (hasError) {
    collapseErrorMsgDisplay[EnumPromotionCollapseId.edm].hasError = true;
    collapseOpen[EnumPromotionCollapseId.edm] = true;
  }

  const _featuredProducts = {
    shopCart: {
      checked: false,
      title: getI18nFromGeneral('general.sider.shoppingCartPage'),
    },
    profile: {
      checked: false,
      title: getI18nFromGeneral('general.sider.profilePage'),
    },
    productSearch: {
      checked: false,
      title: getI18nFromGeneral('general.sider.productSearch'),
    },
    fourZeroFour: {
      checked: false,
      title: getI18nFromGeneral('general.sider.notFound'),
    },
    title: '',
  } as IFeaturedProduct;

  if (featuredProducts) {
    _featuredProducts.shopCart = {
      checked: featuredProducts.showInShoppingCart,
      title: getI18nFromGeneral('general.sider.shoppingCartPage'),
    };
    _featuredProducts.profile = {
      checked: featuredProducts.showInProfile,
      title: getI18nFromGeneral('general.sider.profilePage'),
    };
    _featuredProducts.productSearch = {
      checked: featuredProducts.showInProductSearch,
      title: getI18nFromGeneral('general.sider.productSearch'),
    };
    _featuredProducts.fourZeroFour = {
      checked: featuredProducts.showInPage404,
      title: getI18nFromGeneral('general.sider.notFound'),
    };
  }

  const _edm = {
    homePage: {
      checked: false,
      title: getI18nFromGeneral('general.sider.homepage'),
    },
    profilePage: {
      checked: false,
      title: getI18nFromGeneral('general.sider.profilePage'),
    },
    title: '关注我们',
    description: '请填写邮箱地址关注我们',
    buttonStyle: {
      text: '提交',
      backgroundColor: '',
      textColor: '',
    },
  } as unknown as IEdm;

  if (edm) {
    _edm.homePage = {
      checked: edm.showInHomePage,
      title: getI18nFromGeneral('general.sider.homepage'),
    };
    _edm.profilePage = {
      checked: edm.showInProfilePage,
      title: getI18nFromGeneral('general.sider.profilePage'),
    };
  }

  return {
    uuid,
    hasError,
    featuredProducts: {
      ..._featuredProducts,
      ...featuredProducts,
      products: Array.isArray(featuredProducts?.products)
        ? featuredProducts.products.map((v) => ({
            ...v,
            draggableId: randomNumber(),
          }))
        : [],
    },
    edm: { ..._edm, ...edm },
    popupWindows: _popupWindows,
    storeUuid,
    contentUuid,
    salesChannelContent,
    salesChannelName,
    errorDetail,
    collapseOpen,
    collapseErrorMsgDisplay,
    translationEnabled,
    ...reduxUpdatedStatusControl,
  };
};

export const convertDataFromReduxToServer = (state) => {
  const body = {
    uuid: state.uuid,
    storeUuid: state.storeUuid,
    contentUuid: state.contentUuid,
    featuredProducts: {
      showInShoppingCart: state.featuredProducts.shopCart.checked,
      showInProfile: state.featuredProducts.profile.checked,
      showInProductSearch: state.featuredProducts.productSearch.checked,
      showInPage404: state.featuredProducts.fourZeroFour.checked,
      title: state.featuredProducts.title,
      products: state.featuredProducts.products,
    },
    edm: null,
    popupWindows: {
      inUse: transform(state.popupWindows.inUse),
      pending: transform(state.popupWindows.pending),
      previous: transform(state.popupWindows.previous),
    },
    editingPopupWindows: constructEditing(
      [
        state.popupWindows.editing.id ? state.popupWindows.editing : null,
      ].filter((v) => v),
    ),
  };
  return body;
};

const convertUuidToId = (arr: Array<any>) => {
  return Array.isArray(arr) ? arr.map((a) => ({ ...a, id: a.uuid })) : [];
};

const transform = (list: any) => {
  if (Array.isArray(list)) {
    return list.map((v) => ({
      remark: v.remark,
      //目前只有一种
      promotionType: EnumPromotionPopWindowType.ImageAndLink,
      image: v.image,
      linkTo: v.linkTo,
      beginDate: v.beginDate,
      beginTime: v.beginTime,
      endDate: v.endDate,
      endTime: v.endTime,
      displayFrequency: v.displayFrequency,
      uuid: v.uuid,
    }));
  } else {
    return {
      remark: list.remark,
      //目前只有一种
      promotionType: list.promotionType,
      image: list.image,
      linkTo: list.linkTo,
      beginDate: list.beginDate,
      beginTime: list.beginTime,
      endDate: list.endDate,
      endTime: list.endTime,
      displayFrequency: list.displayFrequency,
      uuid: list.uuid,
      //uuid: v.uuid,
    };
  }
};

const constructEditing = (list: Array<any>) => {
  return list.filter((l) => l && !l.uuid);
};
